import axios from '@/utils/api'

const actions = {
  async finalizar ({ commit }, dae) {
    const result = await axios({
      method: 'post',
      url: 'financeiro/emitDae',
      data: dae
    })

    return result
  },

  async finalizarAnalise ({ commit }, dae) {
    const result = await axios({
      method: 'post',
      url: 'financeiro/emitDaeAnalise',
      data: dae
    })

    return result
  },

  async findDaesByNumeroProcesso ({ commit }, filter) {
    const result = await axios({
      method: 'post',
      url: 'financeiro/findDaeByFilter',
      data: filter
    })

    return result
  },

  async downloadDae ({ commit }, idReceita) {
    await axios({
      method: 'get',
      url: `financeiro/downloadDae/${idReceita}`,
      responseType: 'blob'
    })
  },

  async downloadDaeByBoleto ({ commit }, idBoleto) {
    await axios({
      method: 'get',
      url: `financeiro/downloadDaeByBoleto/${idBoleto}`,
      responseType: 'blob'
    })
  },

  async getBoletosByProcesso ({ commit }, numeroProcesso) {
    const boletos = await axios({
      method: 'get',
      url: 'financeiro/getBoletosByProcesso?processo=' + numeroProcesso
    })
    return boletos
  },

  async findByCodigoEstado ({ commit }, estado) {
    const result = await axios({
      methods: 'GET',
      url: `publico/findByCodigoEstado?codigoEstado=${estado}`
    })
    return result
  },

  async processoPessoa ({ commit }, idProcesso) {
    const result = await axios({
      method: 'GET',
      url: `processo/pessoa/${idProcesso}`,
      error: true
    })
    return result
  },

  async vtnByProcesso ({ commit }, idProcesso) {
    const result = await axios({
      method: 'GET',
      url: `processo/vtn/${idProcesso}`,
      error: true
    })
    return result
  },

  async repacelarSaldoDae ({ commit }, dados) {
    const result = await axios({
      method: 'post',
      url: 'analise/dae/repacelar-saldo',
      data: dados
    })
    return result
  },

  async reemitirDae ({ commit }, idParcela) {
    const result = await axios({
      method: 'post',
      url: `analise/dae/reemitirParcela/${idParcela}`
    })

    return result
  },

  async updateDae ({ commit }, dae) {
    const result = await axios({
      method: 'put',
      url: `analise/dae/reemitirParcela/${dae.id}`,
      data: dae
    })

    return result
  },

  async updateDadosCertidao ({ commit }, dados) {
    const result = await axios({
      method: 'put',
      url: 'calculo/custa/certidao',
      data: dados
    })
    return result
  },

  async getValorBoleto ({ commit }, idProcesso) {
    const result = await axios({
      method: 'get',
      url: `analise/dae/getValorBoleto/${idProcesso}`
    })

    return result
  },

  async jurosDae ({ commit }, dados) {
    const result = await axios({
      method: 'POST',
      url: `financeiro/jurosDae?idVtn=${dados.idVtn}&isVencida=${dados.isVencida}`,
      data: dados.boleto
    })

    return result
  },

  async emitirDaePorParcelaDoVtn ({ commit }, dados) {
    const result = await axios({
      method: 'post',
      url: `financeiro/emitirDaePorParcelaDoVtn?isVencida=${dados.isVencida}`,
      data: dados.parcelaVtn
    })
    return result
  },

  async reemitirDaeVencida ({ commit }, dados) {
    const result = await axios({
      method: 'post',
      url: `financeiro/reemitirDaeVencida?isVencida=${dados.isVencida}`,
      data: dados.parcelaVtn
    })
    return result
  },

  async getBoletosByProcessoByParcela ({ commit }, { processo, referenciaParcela }) {
    const boletos = await axios({
      method: 'get',
      url: `financeiro/getBoletosByProcessoByParcela?processo=${processo}&referenciaParcela=${referenciaParcela}`
    })
    return boletos
  },

  async getBoletosByProcessoByTipoReceita ({ commit }, { numeroProcesso, codigoReceita, id }) {
    const boletos = await axios({
      method: 'get',
      url: `financeiro/getBoletosByProcessoByTipoReceita?processo=${numeroProcesso}&referenciaParcela=${codigoReceita}&idBoleto=${id}`
    })
    return boletos
  },
  async getUltimoBoleto ({ commit }, { processo, referenciaParcela }) {
    const boletos = await axios({
      method: 'get',
      url: `financeiro/getUltimoBoleto?processo=${processo}&referenciaParcela=${referenciaParcela}`
    })
    return boletos
  },
  async existeParcelaByIdVtn ({ commit }, idVtn) {
    const response = await axios({
      method: 'get',
      url: `financeiro/existeParcela/${idVtn}`
    })
    return response
  },

  async existsByParcela ({ commit }, { processo, referenciaParcela }) {
    const exists = await axios({
      method: 'get',
      url: `financeiro/existsByParcela?processo=${processo}&referenciaParcela=${referenciaParcela}`
    })
    return exists
  },

  async existsByDocumentoOrigem ({ commit }, { processo }) {
    const exists = await axios({
      method: 'get',
      url: `financeiro/existsByDocumentoOrigem?processo=${processo}`
    })
    return exists
  },

  async getUltimoBoletoByProcesso ({ commit }, { processo }) {
    const exists = await axios({
      method: 'get',
      url: `financeiro/getUltimoBoletoByProcesso?processo=${processo}`
    })
    return exists
  },

  async getParcelasVtn ({ commit }, { idVtn }) {
    const parcelas = await axios({
      method: 'get',
      url: `financeiro/getParcelasVtn?idVtn=${idVtn}`
    })
    return parcelas
  },

  async emitirDae ({ commit }, { dados }) {
    const boleto = await axios({
      method: 'post',
      url: 'analise/dae',
      data: dados
    })
    return boleto
  }

}

export default {
  namespaced: true,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/financeiro/dae.js